import { render, staticRenderFns } from "./PanelAdminPayAgreements.vue?vue&type=template&id=28583ba0&scoped=true&"
import script from "./PanelAdminPayAgreements.vue?vue&type=script&lang=js&"
export * from "./PanelAdminPayAgreements.vue?vue&type=script&lang=js&"
import style0 from "./PanelAdminPayAgreements.vue?vue&type=style&index=0&id=28583ba0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28583ba0",
  null
  
)

export default component.exports